
import { allowedWrongAnswersPerChapter } from '../constants';
import { questions, currentChapter, chapters, userProgress } from '../stores';
import { chaptersSvc } from './chapters.service';
import { demoSvc } from './demo.service';
import { progressSvc } from './progress.service';
class ExamService {
  constructor() {
    questions
      .subscribe(q => {
        this.q = q || [];
        this._tryUpdateChapter();
      });
    chapters
      .subscribe(chs => {
        this.chapters = chs;
      });
    currentChapter
      .subscribe(ch => {
        if (!ch) {
          return;
        }
        this.currentChapter = ch;
        this.q = [];
        this._tryUpdateChapter();
      });
    userProgress
      .subscribe(up => {
        this.userProgress = up;
        this._tryUpdateChapter();
      });
    }

  _writeToStore() {
    questions.set(this.q);
  }

  _tryUpdateChapter() {
    setTimeout(() => {
      if (this.currentChapter && this.userProgress && this.q && 
          progressSvc.allQuestionsAnswered() && 
          chaptersSvc.getChapterStatus(this.currentChapter.slug) &&
          !progressSvc.examFinished()) {
        this.updateChapter();
      }
    }, 10);
  }

  fixateAnswer(qIndex, selectedAnswers) {
    const answerIndexes = selectedAnswers[qIndex];
    const correctAnswers = this.q[qIndex].answers
      .map((a, i) => {
        return {
          index: i, // store original index
          solution: a.solution
        }
      })
      .filter(a => a.solution)
      .map((a) => (a.index));
  
    const equals = (a, b) =>
      a.length === b.length &&
      a.every((v, i) => v === b[i]);
    
    this.q[qIndex].answerIndexes = answerIndexes;
    this.q[qIndex].status = equals(answerIndexes, correctAnswers);
    this.q[qIndex].fixated = true;
    this._writeToStore();
  }

  resetExam() {
    this.q = this.q.map(q => {
      delete q.answerIndexes;
      delete q.status;
      delete q.fixated;
      return q;
    });
    this.userProgress.chapters[this.currentChapter.slug].status = 'finished';
    this._writeToStore();
  }

  updateChapter() {
    if (this.checkExamNotFinished(this.q, this.currentChapter.slug)) {
      // console.debug('Exam updateChapter nicht möglich. Noch nicht alle Fragen beantwortet.', {'q.len': this.q.length, allQuestionsAnswered: progressSvc.allQuestionsAnswered(), getChapterStatus: chaptersSvc.getChapterStatus(this.currentChapter.slug)});
      return;
    }

    const status = this.q.filter(q => !q.status).length > allowedWrongAnswersPerChapter ? 'failed' : 'success';
    // console.log('Exam updateChapter', this.currentChapter.slug, status, 'persist questions:', demoSvc.isLiveInstance() && status === 'success',  this.q);
    if (chaptersSvc.getChapterStatus(this.currentChapter.slug) === status) {
      // skip update if status is the same
      return;
    }
    chaptersSvc.setChapterStatus(this.currentChapter.slug, status);
    if (status === 'success') {
      chaptersSvc.setNextChapterReady(this.currentChapter.slug);
      demoSvc.isLiveInstance() && progressSvc.setQuestionsProgress(this.q);
    }
  }

  examFinished() {
    return progressSvc.examFinished();
  }

  checkExamNotFinished(q, slug) {
    return !q.length || !progressSvc.allQuestionsAnswered(q) || !['finished', 'failed'].includes(chaptersSvc.getChapterStatus(slug))
  }
}
export const examSvc = new ExamService();